import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { selectCurrency, selectId } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import perupasarelas from '../../../assets/images/KPERU22.png';
import Rkushki from '../../../assets/images/RETIRACONKUSHKI.svg';

const FormKushkiRetiro = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const id_uo = useSelector(selectId);
  const [entidades, setEntidades] = useState([]);
  
  
  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };


  const fetchEntidades = async () => {
    try {
      const response = await axios.get(`https://app.masterbets365.com/API/Kushki/index.php/Api/getBankListOut`);
      if (response.data && response.data.error === 0) {
        const entidadesHabilitadas = response.data.data;
        setEntidades(entidadesHabilitadas);
      } else {
        setEntidades([]); // Si hay un error o no es 0, se limpian las entidades
      }
    } catch (error) {
      setEntidades([]); // En caso de error, también se limpian las entidades
    }
  };
 
  useEffect(() => {
    fetchEntidades();
  }, []);


  return (
    <Form>
      <InputContainer>
        <label>{t("deposit.lbl-bank")}</label>
        <select value={form.bank_id} onChange={handleChange} name='bank_id'>
          <option disabled value=''>{t("deposit.input-bank")}</option>
          {entidades.map((entidad) => (
            <option key={entidad.code} value={entidad.code}>
              {entidad.name}
            </option>
          ))}
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t('deposit.account-number')}:</label>
        <input type='text' placeholder={t('deposit.account-number')} name='account_number' value={form.account_number} onChange={handleChange} />
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.account-type")}:</label>
        <select value={form.tipo_cuenta} onChange={handleChange} name='tipo_cuenta'>
          <option disabled value=''>{t("deposit.select-account-type")}</option>
          <option value='CA'>Cuenta Ahorro</option>
          <option value='CC'>Cuenta Corriente</option>
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.tipodocumento} onChange={handleChange} name='tipodocumento'>
          <option disabled value=''>{t("deposit.select-document-type")}</option>
          <option value='CE'>CE</option>
          <option value='DNI'>DNI</option>
          <option value='PAS'>PAS</option>
          <option value='RUC'>RUC</option>
        </select>
      </InputContainer>

     <InputContainer>
        <label>{t("deposit.id")}</label>
        <input
          type="text"
          placeholder={t("deposit.id")}
          name="document"
          value={form.document}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />
        

        {moneda === 'Sol' && monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'Sol' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
      <img src={Rkushki} alt='RetiraKUSHKI' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={perupasarelas} alt='Pasarelas Kushki' className={'tupa2'} style={{width:'100%', marginTop: '0.5%', marginLeft: '0.2%'}}/>
      
      
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || (monto < 50 && moneda === 'Sol') || (monto > 5000 && moneda === 'Sol')}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormKushkiRetiro;
